import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { SITE_DEFAULTS, deepMerge, resolveImg } from "@/lib/siteDefaults";

const Ctx = createContext(null);

const CACHE_KEY = "site-content-cache-v1";
const readCache = () => { try { return JSON.parse(localStorage.getItem(CACHE_KEY) || "{}"); } catch { return {}; } };

export function SiteContentProvider({ children }) {
  const [raw, setRaw] = useState(readCache);
  const [loaded, setLoaded] = useState(() => Object.keys(readCache()).length > 0);

  const load = async () => {
    try {
      const { data } = await api.get("/site-content");
      setRaw(data || {});
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(data || {})); } catch { /* quota */ }
    } catch {
      setRaw((prev) => prev);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => { load(); }, []);

  const content = deepMerge(SITE_DEFAULTS, raw);
  return <Ctx.Provider value={{ content, loaded, refresh: load, resolveImg }}>{children}</Ctx.Provider>;
}

export function useSiteContent() {
  const c = useContext(Ctx);
  return c || { content: SITE_DEFAULTS, loaded: true, refresh: () => {}, resolveImg };
}
